<template>
  <section class="option-menu">
    <div class="title-holder">
      <span class="title">{{ options.title }}</span
      ><button @click="$emit('showInfo')" v-if="options.showInfo">
        <img src="@/images/icons/info-icon.svg" />
      </button>
    </div>
    <div class="buttons-holder">
      <button
        v-for="(value, propertyName) in options.values"
        class="option-button"
        :class="{ active: value === active }"
        :key="propertyName"
        @click="
          $emit('set-val', options.title, value, options.property, propertyName)
        "
      >
        {{ value }}
      </button>
    </div>
  </section>
</template>

<script>
export default {
  props: ['options', 'active'],
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.option-menu {
  padding: 10px 0;
}

.title-holder {
  margin-bottom: 10px;
  display: flex;
  align-items: center;

  button {
    margin-left: 8px;
  }
}

span {
  font-weight: 500;
}

.buttons-holder {
  //  display: flex;

  button {
    width: 49%;
    text-align: center;
    margin-bottom: 15px;
    background-color: #e7e7e7;

    &.active {
      background-color: var(--sub-color);
    }

    &:nth-of-type(odd) {
      margin-right: 2%;
    }
  }
}
</style>
